import { FormatTypes } from '@constants/templateDictionaries';

export default (data, sectionsToAdd = []) => {
  const { userPreferences, updateVersion, formatType } = data || {};

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      ...userPreferences,
      version: {
        number: updateVersion,
        updated: true,
      },
    };
  }

  const { leftPane } = userPreferences;
  const { used, unUsed } = leftPane;

  const addSectionIfNotPresent = (sectionList, section) => {
    const isPresent = [...used, ...sectionList].some(
      (item) => item?.sectionKey === section?.sectionKey,
    );

    if (isPresent) {
      return sectionList;
    }

    return [
      ...sectionList,
      {
        title: section?.title,
        toExport: false,
        warning: false,
        sectionKey: section?.sectionKey,
      },
    ];
  };

  const updatedUnused = sectionsToAdd?.reduce(
    (acc, section) => addSectionIfNotPresent(acc, section),
    unUsed,
  );

  return {
    ...userPreferences,
    leftPane: {
      ...leftPane,
      unUsed: updatedUnused,
    },
    version: {
      number: updateVersion,
      updated: true,
    },
  };
};
